import axios from 'lib/axios';

const validateCustomerPayment = async (value) => {
  const { data } = await axios.post('/customer/payment/validate', value);
  return data;
};

const getMyPayments = async () => {
  const { data } = await axios.get(`/customer/payments`);
  return data;
};

export { validateCustomerPayment, getMyPayments};
